import { render } from "./LanguageDropdown.vue?vue&type=template&id=6a4baa5f&ts=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__